import { render, staticRenderFns } from "./CommonModalSection.vue?vue&type=template&id=4e2c0d30"
import script from "./CommonModalSection.vue?vue&type=script&lang=ts"
export * from "./CommonModalSection.vue?vue&type=script&lang=ts"
import style0 from "./CommonModalSection.vue?vue&type=style&index=0&id=4e2c0d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports